window.dtUser = function () {
  var user_datatable = new DataTable('#users-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#users-datatable').data('source'),
      data: function (d) {
        // d.begin_date            = $("#datatable-filter-begin-date").val()
        // d.end_date              = $("#datatable-filter-end-date").val()
        // d.line                  = $("#datatable-filter-line").val()
        // d.product_name          = $("#datatable-filter-product-name").val()
        // d.internal_part_id      = $("#datatable-filter-internal-part-id").val()
        // d.customer_part_number  = $("#datatable-filter-customer-part-number").val()
      },
      beforeSend: function () { showLoadingRow('#users-datatable', 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "action" },
      { "data": "status" },
      { "data": "username" },
      { "data": "name" },
      { "data": "email" },
    ],
    columnDefs: [
      {
        targets: [4],
        className: 'text-nowrap'
      }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    }
  });

  // $(document).off("change", "#datatable-filter-begin-date, #datatable-filter-end-date")
  // $(document).on("change", "#datatable-filter-begin-date, #datatable-filter-end-date", function(){
  //   $("#datatable-filter-content").html("")
  //   $("#datatable-filter-content").attr("hidden", "hidden")
  //   user_datatable.ajax.reload()
  // })

  // $(document).off("change", "#datatable-filter-line, #datatable-filter-product-name, #datatable-filter-internal-part-id, #datatable-filter-customer-part-number")
  // $(document).on("change", "#datatable-filter-line, #datatable-filter-product-name, #datatable-filter-internal-part-id, #datatable-filter-customer-part-number", function(){
  //   user_datatable.ajax.reload()
  // })

  dtFinalTouch()
}